module.exports = __webpack_public_path__ + "dc760643c2f01442be3c1967853a6a6e.png";